import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { FC } from "react";


const ITEM_HEIGHT = 38;
const ITEM_PADDING_TOP = 4;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 50,
    },
  },
};

interface DocNoDropDownProps {
    name: string;
    value: string;
    onSelectChange: (event: SelectChangeEvent<string>) => void;
}
export const DocNoDropDown: FC<DocNoDropDownProps> = ({
    name,
    value,
    onSelectChange,
}) => {
    return (
        <FormControl sx={{ minWidth:60, mx:0, mt:.6}} size="small">
        <Select 
          name={name}
          value={value}
          onChange={onSelectChange}
          MenuProps={MenuProps}
          sx={{fontFamily:'B Nazanin', fontSize:12, fontWeight:500, border:'.4px solid rgb(196, 199, 199)', borderRadius:2}}
        >
            {[...Array(1001)].map((_, i) => 
            {
              return(
                <MenuItem
                    key={name + i}
                    value={i.toString()}
                    sx={{fontFamily:'B Nazanin', fontSize:14, fontWeight:600, direction:'rtl'}}
                >
                    {i}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl> 
    )
}
 